/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import AiManagementSummaryCard from 'components/atoms/ai_management_summary_card';
import AiManagementDataCard from 'components/molecules/ai_management_data_card';
import { PossibleCompetitorReasons } from 'services/actions/ai_management_possible_competitors';
import { count, plural } from 'services/ai_management_format';
import { Content } from './styles';

interface AiManagementCompetitorReasonsProps {
  title: string;
  reasons: PossibleCompetitorReasons;
  className?: string;
}

const PREVIEW = 5;

const AiManagementCompetitorReasons: React.FC<AiManagementCompetitorReasonsProps> = ({
  title,
  reasons,
  className = '',
}) => {
  const [expanded, setExpanded] = useState(false);
  const rows = expanded ? reasons.motivos : reasons.motivos.slice(0, PREVIEW);
  const hidden = reasons.motivos.length - PREVIEW;
  const notes = [
    reasons.outros_motivos > 0
      ? `${plural(reasons.outros_motivos, 'outro motivo', 'outros motivos')} em ${plural(
          reasons.outros_itens,
          'item',
          'itens',
        )}`
      : null,
    reasons.sem_motivo_itens > 0
      ? plural(reasons.sem_motivo_itens, 'item sem motivo informado', 'itens sem motivo informado')
      : null,
  ].filter((note): note is string => Boolean(note));

  return (
    <Content className={className}>
      <h6 className="reasons-title font-weight-bold mb-2">{title}</h6>
      {reasons.texto ? (
        <AiManagementSummaryCard title="" className="mb-3">
          {reasons.texto}
        </AiManagementSummaryCard>
      ) : null}
      <AiManagementDataCard compact>
        <div className="table-responsive">
          <table className="table bg-white mb-0">
            <thead className="thead-light">
              <tr>
                <th scope="col">Motivo</th>
                <th scope="col" className="text-right text-nowrap">
                  Quant. Licitações
                </th>
              </tr>
            </thead>
            <tbody>
              {rows.length ? (
                rows.map((reason) => (
                  <tr key={reason.texto}>
                    <td className="reason-cell">
                      <span title={reason.texto}>{reason.texto}</span>
                    </td>
                    <td className="text-right">{count(reason.licitacoes)}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={2} className="text-muted">
                    Nenhum motivo registrado.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {hidden > 0 || notes.length ? (
          <div className="reasons-footer d-flex align-items-center justify-content-between flex-wrap border-top px-3 py-2">
            <small className="text-muted">{notes.join(' • ')}</small>
            {hidden > 0 ? (
              <button
                type="button"
                className="btn btn-link btn-sm p-0 ml-auto"
                onClick={() => setExpanded((current) => !current)}
              >
                {expanded ? 'Ver menos' : `Ver todos (${reasons.motivos.length})`}
              </button>
            ) : null}
          </div>
        ) : null}
      </AiManagementDataCard>
    </Content>
  );
};

export default AiManagementCompetitorReasons;
